<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      {{
        info.id ? "Cập nhật thông số kỹ thuật" : "Thêm mới thông số kỹ thuật"
      }}
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col cols="4">
              <ValidationProvider
                name="Công dụng"
                rules="required"
                v-slot="{ errors }"
              >
                <base-input
                  label="Công dụng"
                  :error="errors[0]"
                  v-model="info.deportment"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
            <b-col>
              <base-input
                label="Nguyên liệu"
                v-model="info.material"
              ></base-input>
            </b-col>
            <b-col>
              <base-input label="Quy cách" v-model="info.spec"></base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <color
                label="Màu sắc"
                :error="!info.color || !info.color.id"
                v-model="info.color"
              ></color>
            </b-col>
            <b-col>
              <base-input
                label="Mã màu 1"
                v-model="info.colorCode1"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                label="Mã màu 2"
                v-model="info.colorCode2"
              ></base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-input
                label="Số lượng sợi"
                type="text"
                v-model="info.quantity"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                label="% Sợi"
                type="number"
                v-model="info.percentYarn"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                label="% Hao hụt"
                type="number"
                v-model="info.percentLoss"
              ></base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-input
                label="Số lượng mẫu"
                type="number"
                readonly
                v-model="Specify.quantity_default"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                label="Trọng lượng (ước tính)"
                type="number"
                readonly
                v-model="info.weight"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                label="Tổng Trọng lượng"
                type="number"
                placeholder="Trọng lượng sau khi trừ hao hụt"
                readonly
                v-model="info.total_weight"
              ></base-input>
            </b-col>
          </b-row>
        </form>
        <hr />
        <button type="button" @click="handleClose" class="btn btn-secondary">
          Đóng
        </button>
        <button type="button" @click="doSave(1)" class="btn btn-success">
          Lưu tiếp (Shift + F4)
        </button>
        <button type="submit" @click="doSave(0)" class="btn btn-dark">
          Lưu đóng (F4)
        </button>
      </ValidationObserver>
    </block>
    <event
      @doSave="doSave(0)"
      @doCancel="handleClose"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>
<script>
import { productService } from "@/_services";
export default {
  props: {},
  data() {
    return {
      visible: false,
      info: {
        quantity: 0,
        percentYarn: 0,
        percentLoss: 0,
        weight: 0,
        total_weight: 0
      },
      Specify: {},
      ownInfo: {}
    };
  },
  methods: {
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        if (self.info.id) {
          productService
            .specSaveFeature(self.info, self.Specify.id)
            .then(res => {
              self.ownInfo.deportment = res.data.deportment;
              self.ownInfo.material = res.data.material;
              self.ownInfo.spec = res.data.spec;
              self.ownInfo.color = res.data.color;
              self.ownInfo.colorCode1 = res.data.colorCode1;
              self.ownInfo.colorCode2 = res.data.colorCode2;
              self.ownInfo.quantity = res.data.quantity;
              self.ownInfo.weight = res.data.weight;
              self.ownInfo.percentLoss = res.data.percentLoss;
              self.ownInfo.total_weight = res.data.total_weight;
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              if (type == 0) {
                self.visible = false;
              }
              this.$refs.bmdal.unBlock();
            });
        } else {
          productService
            .specSaveFeature(self.info, self.Specify.id)
            .then(res => {
              self.$alertify.success("Thêm thành công");
              self.info = {
                quantity: 0,
                percentYarn: 0,
                percentLoss: 0,
                weight: 0,
                total_weight: 0
              };
              self.Specify.productFeatures.unshift(res.data);
              if (type == 0) {
                self.visible = false;
              }
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              self.$refs.bmdal.unBlock();
            });
        }
      });
    },
    setData(Specify, info) {
      this.Specify = Specify;
      if (info) {
        this.ownInfo = info;
        this.info = Object.assign({}, info);
      } else {
        this.info = {
          quantity: 0,
          percentYarn: 0,
          percentLoss: 0,
          weight: 0,
          total_weight: 0
        };
      }
    },
    handleClose() {
      this.visible = false;
    },
    calcWeigth() {
      this.info.weight = Number(
        (
          ((Number(this.Specify.quantity_default) *
            Number(this.Specify.quota)) /
            1000) *
          (Number(this.info.percentYarn) / 100)
        ).toFixed(2)
      );
      this.info.total_weight = Number(
        (
          this.info.weight +
          (this.info.weight * Number(this.info.percentLoss)) / 100
        ).toFixed(2)
      );
    }
  },
  watch: {
    "info.percentYarn": function() {
      this.calcWeigth();
    },
    "info.percentLoss": function() {
      this.calcWeigth();
    }
  }
};
</script>
